import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import "./manageOrganization.css";
import { getUnitAPI, purchaseItemsGetByFactoryId, getPurchasedItem } from "api";
import { withTranslation } from "react-i18next";
import moment from "moment";

class CompanyMaterialStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      materialStockList: [],
      factoryList: [],
      factoryId: "",
    };
  }

  async componentDidMount() {
    const factory = await getUnitAPI({isInternal:true});
    if(factory && factory.data){
      this.setState({
        factoryList: factory.data.factories,
      });
    }
   
    this.getFactoryId({ target: { value: "" } });
  }

  getFactoryId = async e => {
    this.setState(
      { materialStockList: [], factoryId: e.target.value },
      async () => {
        if (this.state.factoryId === "") {
          const materialStockList = await getPurchasedItem({piecesQuantity: null, page:null, limit: null, factoryId: null});
          this.setState({
            materialStockList: materialStockList.data.purchasedItems,
          });
        } else {
          const materialStockList = await purchaseItemsGetByFactoryId(
            this.state.factoryId
          );
          this.setState({
            materialStockList: materialStockList.data,
          });
        }
      }
    );
  };

  render() {
    const columns = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
      },
      {
        dataField: "itemname",
        text: `${this.props.t("Item Name")}`,
        formatter: (cll, row) => {
          return row.item.name;
        },
      },
      {
        dataField: "consumptiontype",
        text: `${this.props.t("Consumption Type")}`,
        formatter: (cll, row) => {
          return row.item.comsumptionType;
        },
      },
      {
        dataField: "piecesQuantity",
        text: `${this.props.t("Total Quantity")}`,
      },
      {
        dataField: "freshstock",        
        text: `${this.props.t("Fresh Stock(Box)")}`,
        formatter: (cll, row) => {
          if (row.piecesQuantity == 0) {
            return 0;
          } else {
            return row.piecesQuantity - row.inUse;
          }
        },
      },
      {
        dataField: "inUse",
        text: `${this.props.t("In Use(Allocated)")}`,
      },
      {
        dataField: "purchaseDate",
        text: `${this.props.t("Purchase Date")}`,
        formatter:(cell, row) => {
          return moment(row.createdAt).format("DD/MM/YYYY")
        }
      },
      {
        dataField: "edit",
        text:`${this.props.t('View Details')}`,
        formatter: (cell, row) => (
          <Link
            to={{
              pathname: "/add-purchased-item",
              query: { isEdit: true, data: row },
            }}
          >
            <button className="py-2 px-2 border-0 rounded">
              <img src="images/dashboard-images/edit.svg" />
            </button>
          </Link>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.materialStockList.length, // replace later with size(customers),
      custom: true,
    };

    //meta title
    document.title = "manage organisation";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.materialStockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.materialStockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <Row>
                      <Col xl="6" lg="12">
                        <h3 className="text-black fw-bold text-uppercase">
                          {this.props.t("Material Stock")}
                        </h3>
                      </Col>
                      <Col
                        xl="6"
                        lg="12"
                        className="text-start text-xl-end pt-4 pt-lg-0"
                      >
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 pe-lg-3"
                            >
                              {this.props.t("Search Factory(Unit) Name")}
                            </label>
                            <select
                              id="factoryId"
                              className="select-field"
                              onChange={e => this.getFactoryId(e)}
                            >
                              <option value="">All</option>
                              {this.state.factoryList?.map(x => (
                                <option key={x.id} value={x.id}>
                                  {x.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <h4 className="pt-4 fw-bold text-black">
                              {this.props.t("Material Stock")}{" "}
                            </h4>

                            <React.Fragment>
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex"></Col>
                              </Row>
                              <Row className="mb-2"></Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Col className="inner-custom-pagination mt-4">
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(CompanyMaterialStock);
